<ul
  #list
  role="listbox"
  tabindex="0"
  aria-label="Liste mit auswählbaren Angeboten"
  aria-roledescription="Mit Enter kann ein Angebot aus der Liste ausgewählt werden und die Inhalte des Angebots sowie dessen Termine werden angezeigt."
  class="now-card-stack mb-0 ps-0"
  [attr.aria-activedescendant]="activedescendant"
  (keyup.arrowup)="moveUp()"
  (keyup.arrowdown)="moveDown()"
  (keyup.enter)="this.setFocusedAngebot()"
  (focus)="focusin()"
  (click)="onUlClick()"
>
  @for (angebot of angebote; track angebot.id; let index = $index) {
    <li
      #listItem
      [attr.id]="getListItemId(angebot.id)"
      class="now-card now-link-card now-with-tag"
      [ngClass]="{
        selected: angebot.id === selectedAngebotId || getIsActive(index),
        focused: focusedIndex === index
      }"
      role="option"
      [attr.aria-selected]="getIsActive(index)"
      [attr.aria-labelledby]="'angebot_' + angebot.id + '_heading'"
      (click)="this.selectAngebot(angebot.id, $event)"
    >
      <now-wbsuche-lib-angebot-list-item
        [angebot]="angebot"
        [selected]="selectedAngebotId === angebot.id"
      ></now-wbsuche-lib-angebot-list-item>
    </li>
  }
</ul>
